import Vue from 'vue';
import axios from 'axios';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import messages from '@/locale';

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // 默认语言
  messages, // 多语言配置
});

new Vue({
    el: '#app',
    i18n,
    router,
    template: '<App/>',
    components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js